import { render } from "./StreamsWidgetBreaks.vue?vue&type=template&id=78fb4d40"
import script from "./StreamsWidgetBreaks.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsWidgetBreaks.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/StreamsWidgetBreaks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78fb4d40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78fb4d40', __exports__)) {
    api.reload('78fb4d40', __exports__)
  }
  
  module.hot.accept("./StreamsWidgetBreaks.vue?vue&type=template&id=78fb4d40", () => {
    api.rerender('78fb4d40', render)
  })

}


export default __exports__